import { WorkOrderDto, WorkOrderObjectHierarchyDto } from '@app/generated/model';
import { WorkOrderActions, WorkOrderActionTypes } from '@dwo/actions';
import { WorkLineModel, WorkOrderObjectModel } from '@app/work-order/objects/work-order-object.model';
import { applyWorkLineActionToHierarchy, applyWorkLineActionToSelectedWorkLines } from './work-line-updates';

export const initialState: WorkOrderState = {
  workOrders: [],
  currentWorkOrder: null,
  hierarchy: [],
  selectedWorkLines: [],
  selectedObjects: [],
  activeMarkupDocumentId: null,
};

export interface WorkOrderState {
  workOrders: WorkOrderDto[];
  currentWorkOrder: WorkOrderDto;
  hierarchy: WorkOrderObjectHierarchyDto[];
  selectedWorkLines: WorkLineModel[];
  selectedObjects: WorkOrderObjectModel[];
  activeMarkupDocumentId: string | null;
}

export function workOrderReducer(state: WorkOrderState = initialState, action: WorkOrderActions): WorkOrderState {
  switch (action.type) {
    case WorkOrderActionTypes.LoadWorkOrderSuccess:
      return {
        ...state,
        currentWorkOrder: action.workOrder,
      };
    case WorkOrderActionTypes.LoadWorkOrderObjectsSuccess:
      return {
        ...state,
        hierarchy: action.operations,
      };
    case WorkOrderActionTypes.UpdateWorkLineProgress:
    case WorkOrderActionTypes.UpdateWorkLineQuantity:
    case WorkOrderActionTypes.UpdateWorkLineCableLength:
    case WorkOrderActionTypes.MarkWorkLineAsComplete:
    case WorkOrderActionTypes.ReOpenWorkLine:
      return {
        ...state,
        hierarchy: applyWorkLineActionToHierarchy(state.hierarchy, action),
        selectedWorkLines: applyWorkLineActionToSelectedWorkLines(state.selectedWorkLines, action),
      };
    case WorkOrderActionTypes.SelectWorkLine:
      return {
        ...state,
        selectedWorkLines: [...state.selectedWorkLines, action.workLine],
      };
    case WorkOrderActionTypes.DeSelectWorkLine:
      return {
        ...state,
        selectedWorkLines: state.selectedWorkLines.filter((wl) => wl.id !== action.workLine.id),
      };
    case WorkOrderActionTypes.SelectObject:
      return {
        ...state,
        selectedObjects: [...state.selectedObjects, action.object],
      };
    case WorkOrderActionTypes.DeSelectObject:
      return {
        ...state,
        selectedObjects: state.selectedObjects.filter((obj) => obj.id !== action.object.id),
      };
    case WorkOrderActionTypes.SelectAllObjects:
      const workLines = action.parentObjects.map((obj) => obj.workLines).flat();
      const objects: WorkOrderObjectModel[] = action.parentObjects.map((obj) => obj);
      return {
        ...state,
        selectedObjects: objects,
        selectedWorkLines: workLines,
      };
    case WorkOrderActionTypes.DeselectAllObjects:
      return {
        ...state,
        selectedObjects: [],
        selectedWorkLines: [],
      };
    case WorkOrderActionTypes.OpenMarkupDocument:
      return { ...state, activeMarkupDocumentId: action.documentId };
    case WorkOrderActionTypes.ClearMarkupDocument:
      return { ...state, activeMarkupDocumentId: null };
    default:
      return state;
  }
}
